import React, { useContext } from 'react';
import { TooltipProps } from "recharts";
import { ColorModeContext } from '../../contexts/color-mode';

export const CustomTooltip = ({ active, payload, label }: TooltipProps<number, string>) => {
  const { mode } = useContext(ColorModeContext);
  
  if (!active || !payload || !payload.length) {
    return null;
  }

  const tooltipStyle = {
    backgroundColor: mode === 'dark' ? 'black' : 'white',
    border: '1px solid hsl(var(--border))',
    padding: '10px',
    borderRadius: '8px',
    boxShadow: mode === 'dark' 
      ? '0 4px 6px -1px rgba(0, 0, 0, 0.5)' 
      : '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
  };

  return (
    <div style={tooltipStyle}>
      <p style={{ 
        margin: '0 0 8px',
        color: 'hsl(var(--foreground))',
        fontWeight: 500,
      }}>
        {label}
      </p>
      {payload.map((entry, index) => (
        <p
          key={`item-${index}`}
          style={{
            color: entry.color,
            margin: '4px 0',
            fontSize: '0.875rem',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <span
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: entry.color,
            }}
          />
          {`${entry.name}: ${entry.value}`}
        </p>
      ))}
    </div>
  );
}; 